module.exports = __webpack_public_path__ + "img/oneocean.55eab93f.svg";